import { GTIWebButton, Dialog, Typography, Grid, Box, Stack, Icon } from "@gti-controls-v2/web-core";
import useTranslation from "../../../hooks/useTranslation";
import consumosStyles from "../../../common/styles/Consumos";
import { titleIcons } from "../../../common/constants/TitleIcons";
import { useMediaQueryCustom } from "../../../hooks/useMediaQueryCustom/useMediaQueryCustom";
import customTheme from "../../../theme";

export const DialogoHacerCorte = (props) => {

  const { t } = useTranslation();
  const styles = consumosStyles;
  const { isLaptopDesktop } = useMediaQueryCustom();

  const handleHacerCorte = () => {
    props.ejecutarCorte();
    props.setDialogoHacerCorteOpen(false);
  };

  const handleClose = () => {
    props.setDialogoHacerCorteOpen(false);
  };

  return (
    <>
      <Dialog
        open={props.dialogoHacerCorteOpen}
        maxWidth="sm"
        fullWidth
        sx={
          {
              '.MuiPaper-root': {
                  width: isLaptopDesktop ? 600 : 450
              },
          }
      }
      >
        <Box sx={consumosStyles.modal}>
          <Grid container justify="flex-end">
            <Grid item xs={12}>
              <Box sx={styles.modalHeader}>
                <Box>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                  />
                  <Icon
                    fontSize={"large"}
                    sx={{
                      color: titleIcons.warning.color,
                      marginRight: "16px",
                    }}
                  >
                    {titleIcons.warning.src}
                  </Icon>

                </Box>
                <Box sx={styles.modalHeaderText} style={{alignSelf: "center"}}>
                  <Typography variant="h6" sx={styles.modalTitle} fontSize={isLaptopDesktop ? "24px" : "18px"}>
                    {t("sistema.modal.hacerCorte.titulo")}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ pb: 4 }}>
                <Typography variant="body2" fontSize={isLaptopDesktop ? "22px" : "16px"}>
                  {t("sistema.modal.hacerCorte.descripcion")}
                  <br />
                  {t("sistema.modal.hacerCorte.descripcion2")}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box sx={styles.modalButtons}>
                <Box sx={styles.spacer} />
                <Box>
                  <Stack width="100%" direction="row">
                    <GTIWebButton
                      sx={
                        {
                          fontSize: isLaptopDesktop ? "16px" : "20px",
                          height: isLaptopDesktop ? "43px" : "32px",
                          marginLeft: customTheme.spacing(2),
                        }
                      }
                      //sx={styles.modalActionButton}
                      text={t("sistema.modal.hacerCorte.acciones.hacerCorte")}
                      width={"100%"}
                      onClick={handleHacerCorte}
                    />
                    <GTIWebButton
                      variant="text"
                      sx={
                        {
                          fontSize: isLaptopDesktop ? "16px" : "20px",
                          height: isLaptopDesktop ? "43px" : "32px",
                          marginLeft: customTheme.spacing(2),
                        }
                      }
                      //sx={styles.modalActionButton}
                      text={t("sistema.modal.hacerCorte.acciones.cancelar")}
                      width={"100%"}
                      onClick={handleClose}
                    />
                  </Stack>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
    </>
  )
}
